/* Copyright (c) 2022 VMware, Inc. All rights reserved. -- VMware Confidential */
import { Event } from "@app/services/dispatcher/events/event";

export class ViewInitEvent extends Event {
    public static ID: string = "ON_INIT";

    constructor(public type: string = ViewInitEvent.ID) {
        super(ViewInitEvent.ID);
    }
}
